/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import DownloadOutline from './download-outline-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <DownloadOutline {...validProps} />;
}
SvgComponent.iconName = 'downloadOutline';

export const DownloadOutlineIcon = svgIconWrapper(SvgComponent);
